module.exports = __webpack_public_path__ + "img/healer.6fd40b00.jpg";